import React from 'react';

import { Paper, makeStyles, Grid, NoResults } from '@gogame/components';
import { Screen, withScreen, createScreenRoute } from '@gogame/screens';

import ExportForm from 'scenes/AssistedInstalls/components/ExportForm';
import { useExportAssistedInstalls } from 'scenes/AssistedInstalls/data/mutations';

import { assistedInstallsParams, assistedInstallsLink } from './navigation';
import { downloadSchema } from './schemas';
import screenReducer from './screenReducer';

const id = 1081;
const permission = 91;

const useStyles = makeStyles((theme) => ({
  paper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  sidebar: {
    padding: '0',
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  content: {
    padding: '24px',
  },
  root: {
    flexGrow: 1,
  },
}));

const AssistedInstalls = withScreen({
  name: 'assisted-installs',
  searchParams: assistedInstallsParams,
  reducer: screenReducer,
})(() => {
  const classes = useStyles();

  const [exportAI] = useExportAssistedInstalls();

  const handleExport = (data) => {
    exportAI(data);
  };

  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <Paper variant={'outlined'} className={classes.paper}>
          <Grid container className={classes.root}>
            <Grid item xs={3} className={classes.sidebar}>
              <ExportForm
                onSubmit={handleExport}
                initialValues={downloadSchema.default()}
              />
            </Grid>
            <Grid item xs={9} className={classes.content}>
              <NoResults
                inited={true}
                noResultsLabel={`Assisted installs (AKA multi-touch attribution) are installs
          where the media source/campaign didn't have the last touch but
          did touch the user before the install and during the attribution
          window. Analytical data of assisted installs are available at
          both the media source and campaign levels to measure the broader
          impact of each media source and campaign.`}
              />
            </Grid>
          </Grid>
        </Paper>
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Assisted Installs',
  link: assistedInstallsLink,
  screen: <AssistedInstalls />,
  id: id,
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/19641662438812-Assisted-Installs',
});
